import { useHistory, useParams } from "react-router-dom";
import '../../../../../assets/css/providercustomers.css';
import '../../../../../assets/css/bookings.css';
import * as common from "../../../common/__redux/commonRedux";
import { connect } from "react-redux";
import back from "../../../../../assets/icons/ic_caret_left.svg";
import { useEffect, useState } from "react";
import { useDictionary } from "../../../../../utilities/hooks/UseDictionary";
import trash from '../../../../../assets/icons/ic_trash.svg';
import SimpleLoader from "../../../common/SimpleLoader";
import CustomerBooking from "./tabs/Booking/CustomerBooking";
import CustomerReview from "./tabs/Activity/CustomerReview";
import CustomerDetails from "./CustomerDetails";
import CustomerHandlerForms from "../CustomerHandlerForms";
import { deleteCutomer, getProviderCustomer } from "../networking";
import ConfirmationModal from '../../../common/ConfirmationModal';
import ProfileImage from "../../../common/ProfileImage";
import CustomToast from "../../../common/CustomToast";
import { toast, ToastContainer } from 'react-toastify';

const ProviderCustomersDetails = () => {
    const history = useHistory();
    const params = useParams();
    const dictionary = useDictionary();
    
    const [opacity, setOpacity] = useState(0);
    const [details, setDetails] = useState(null);
    const [showLoader, setLoaderVisibility] = useState(true);
    const [tabIndex, setTabIndex] = useState(0);
    const [showCustomerForm, setShowCustomerForm] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    const dismiss = () => {
		history.goBack();
	};

    useEffect(() => {
        setTimeout(() => {
            setOpacity(1);
        }, 10);
        getProviderCustomersAsync();
    }, []);

    const getProviderCustomersAsync = async() =>{
        setLoaderVisibility(true);
        try {
            const {data} = await getProviderCustomer(params.id)
            setDetails(data);
            setLoaderVisibility(false);
        } catch (error) {
            setLoaderVisibility(false);
            if (error?.response?.data?.message) {
                toast.error(<CustomToast message={error.response.data.message} />, {
                    position: 'top-right',
                    toastId: 'customer-detail-1',
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    closeButton: false,
                    icon: false,
                    className: 'toast-white-error'
                });
            }
            setTimeout(() => {
                dismiss();
            }, 1000);
        }
    }

    const handleDetele = () => {
        if(!details) {
            return;
        }
        setShowDeleteDialog(true);
    }

    const detailsEditHandler = () => {
        setShowCustomerForm(true);
    }

    const deleteCustomerAsync = async(onSuccess, onFail) => {
		// Delete customer logic here
		try {
			await deleteCutomer(details.id)
			onSuccess();
		} catch (error) {
			onFail();
		}
	}

    const routeMap = {
		0: <CustomerBooking details={details} />,
		1: <CustomerReview details={details} />,
	};
    return (
        <div
			className="provider-customer-calendar-container"
			style={{
				background: 'var(--background-color)',
				paddingTop: '0'
			}}
		>
            <div className="booking-details-wrapper" style={{ opacity: opacity }}>
                <div className={"booking-header-container provider-customer-header-container-details"}>
                    <div className="d-flex-center">
                        <div className="booking-detail-back-button" onClick={dismiss}>
                            <img src={back} />
                        </div>
                        <div className="d-flex-center provider-customer-name-image-wrapper">
                            <div className="provider-customer-avatar">
                                <ProfileImage name={details?.name} photo={details?.avatar_url} size={{width: 40, height: 40, fontSize: 14, lineHeight: 16}}/>
                            </div>
                            <h2 className="title-main truncate" title={details?.name}>{details?.name}</h2>
                        </div>
                    </div>
                    <div className="d-flex provider-customers-actions-button">
                        <div className="provider-customers-create-booking">
                            <div
                                onClick={handleDetele}
                                className={`button provider-upload-button`}
                            >
                                <img src={trash}/>
                                {dictionary.delete}
                            </div>
                            {/* <div
                                onClick={createBookings}
                                className={`button provider-create-button`}
                            >
                                <div className="plus-icon" />
                                {dictionary.providerCreateNewBookingButton}
                            </div> */}
                        </div>
                        {/* <div className="provider-upload-customers-button">
                            <div
                                onClick={handleDetele}
                                className={`button provider-upload-button`}
                            >
                                <img src={trash}/>
                                {dictionary.delete}
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="booking-details-body">
					<div className="booking-details-container" style={{maxHeight: 'calc(100vh - 248px)'}}>
						<div className="settings-tab-bar">
							<div
								onClick={() => setTabIndex(0)}
								className={tabIndex === 0 ? "settings-tab settings-tab-active" : "settings-tab"}
							>
								{dictionary.bookings}
							</div>
                            {!!(details?.reviews && details?.reviews.length) && (
                                <div
                                    onClick={() => setTabIndex(1)}
                                    className={
                                        tabIndex === 1
                                            ? 'settings-tab settings-tab-active'
                                            : 'settings-tab'
                                    }
                                >
                                    {dictionary.providerReviews}
                                </div>
                            )}
						</div>
						{details ? routeMap[tabIndex] : null}
						<SimpleLoader showLoader={showLoader} />
					</div>
					{details ? <CustomerDetails details={details} detailsEditHandler={detailsEditHandler} /> : null}
				</div>
            </div>
            <ToastContainer/>
            {showCustomerForm ? (
				<CustomerHandlerForms
					type={'edit'}
					showDialog={showCustomerForm}
					setShowDialog={setShowCustomerForm}
					customerSaveEvent={getProviderCustomersAsync}
					editId={details.id}
				/>
			) : null}
            {showDeleteDialog ? (
				<ConfirmationModal
					onActionFinished={dismiss}
					setShowModal={setShowDeleteDialog}
					asyncTask={deleteCustomerAsync}
					title={dictionary.customer_deleted}
					message={dictionary.customer_delete_message}
					successMessage={dictionary.customer_deleted_success_message}
					errorMessage={dictionary.customer_problem_deleting_booking}
					action={dictionary.delete}
				/>
			) : null}
        </div>
    )
}

export default connect(common.states, common.actions)(ProviderCustomersDetails);